import { RiGraduationCapFill } from "react-icons/ri";
import { MdHealthAndSafety, MdPsychologyAlt } from "react-icons/md";
import { IoIosPeople } from "react-icons/io";
import { SiElectronbuilder } from "react-icons/si";
import { PiStrategyBold } from "react-icons/pi";

export const homeThematics = [
  {
    name: "Education",
    description:
      "Nurturing education from Kindergarten to university, we provide uniforms, materials, fees, tutorials, supporting holistic learning for children.",
    href: "#education",
    icon: RiGraduationCapFill,
  },
  {
    name: "Health",
    description:
      "Tackling HIV/AIDS, we prioritize awareness, tests, care referrals. Education, peers, primary care, reproductive health nurture overall wellness.",
    href: "#health",
    icon: MdHealthAndSafety,
  },
  {
    name: "Psychosocial Care and Support",
    description:
      "Our Psychosocial program attends to children's and families' needs through counseling, social support, homes, education, sports, and awareness creation.",
    href: "#psychosocial",
    icon: MdPsychologyAlt,
  },
  {
    name: "Livelihood",
    description:
      "Empowering youth with skills, education support, startup funds, entrepreneurship. Hope for Children Organization fosters self-reliance and growth.",
    href: "#livelihood",
    icon: IoIosPeople,
  },
  {
    name: "Capacity Building",
    description:
      "Empowering communities through groups and Anti-AIDS clubs, advancing rights, governance, peace, and promoting environment protection.",
    href: "#capacity",
    icon: SiElectronbuilder,
  },
  {
    name: "Strategies",
    description:
      "Hope for Children's initiatives encompass education, care, homes, peer education, awareness, capacity building, savings, and income generation.",
    href: "#strategies",
    icon: PiStrategyBold,
  },
];

export const Programthematics = [
  {
    name: "Education",
    description:
      "At Hope for Children, we believe in the transformative power of education. Our mission is to empower young minds by providing comprehensive support for learning. From nurturing kindergarten potential to guiding university aspirations, we ensure a well-rounded educational journey.",
    id: "education",
    points: [
      "Access to education from kindergarten to university level.",
      "Provision of uniforms, school materials, fees, and tutorials.",
      "Empowering children with knowledge and skills for a brighter future.",
      "Investing in education as a key to breaking cycles of poverty.",
      "Collaborating with families to ensure children's educational success.",
    ],
  },
  {
    name: "Health",
    description:
      "Empowering over 86,871 People living with HIV/AIDS since 2000, Hope for Children prioritizes comprehensive HIV/AIDS prevention, care, and support. Our initiatives encompass awareness programs, testing and treatment services, counseling, sexual and reproductive health education, and primary care.",
    id: "health",
    points: [
      "Holistic approach to HIV/AIDS prevention, care, and support.",
      "Engaging awareness programs, counseling, and referrals.",
      "Educational focus on sexual and reproductive health.",
      "Providing medical diagnosis, treatment, and support for vulnerable children.",
      "Ensuring access to medical services for children in need.",
    ],
  },

  {
    name: "Psychosocial Care and Support",
    description:
      "Uplifting lives through emotional well-being, Hope for Children focuses on the social and psychological needs of vulnerable children and their families. Our initiatives include grief and individual counseling, social services, education, recreation, and holistic support.",
    id: "psychosocial",
    points: [
      "Addressing social and psychological needs of vulnerable children and families.",
      "Providing grief and individual counseling services.",
      "Enabling emotional support for both adults and children.",
      "Offering group homes, sponsorship, and essential support.",
      "Building life skills, fostering empowerment and resilience.",
      "Raising awareness about challenges, vision, and needs.",
    ],
  },

  {
    name: "Livelihood",
    description:
      "Empowering futures, Hope for Children focuses on building sustainable livelihoods for young individuals beyond our care. Our initiatives include skill training, support for higher education, capital for income-generating activities, and savings schemes.",
    id: "livelihood",
    points: [
      "Promoting sustainable livelihoods for young individuals.",
      "Offering skill training for empowerment and self-reliance.",
      "Supporting higher education for personal growth.",
      "Providing starting capital for income-generating activities.",
      "Empowering through savings and credit schemes.",
    ],
  },
  {
    name: "Capacity Building",
    description:
      "Empowering communities for change, Hope for Children focuses on enhancing the capacity of local organizations and individuals. Our initiatives encompass support to community-based groups, Anti-AIDS clubs, and advocacy for human rights, governance, and environmental protection.",
    id: "capacity",
    points: [
      "Strengthening community-based groups for impact.",
      "Empowering Anti-AIDS clubs and community engagement.",
      "Advocating for human rights, governance, and transparency.",
      "Promoting conflict resolution and peace-building efforts.",
      "Championing environmental protection and green initiatives.",
    ],
  },
  {
    name: "Strategies",
    description:
      "Navigating towards impact, Hope for Children employs dynamic strategies to achieve its mission. Our approach includes providing educational support, psychosocial care, and group homes for vulnerable children. We empower through peer education, community sensitization, capacity building of community groups, and promoting economic empowerment initiatives.",
    id: "strategies",
    points: [
      "Educational support for children in need.",
      "Psychosocial care for vulnerable children and families.",
      "Group homes providing a nurturing environment.",
      "Empowering youth through peer education and rights awareness.",
      "Community sensitization and entertainment for awareness.",
      "Capacity building of community groups like Iddirs and youth clubs.",
      "Promoting savings and credit groups for financial growth.",
      "Empowering through Income Generating Activities.",
    ],
  },
];
